export default function () {
    console.log('# initializing accordions')
    var accordions = document.querySelectorAll('[data-accordion]')
    var triggers = document.querySelectorAll('[data-accordion-trigger]')
    var contents = document.querySelectorAll('[data-accordion-content]')

    console.log('Found accordions:', accordions.length)

    if (!accordions.length || !triggers.length || !contents.length) {
        console.warn('Missing accordion elements', {
            accordions: accordions.length,
            triggers: triggers.length,
            contents: contents.length,
        })
        return
    }

    // Remove any existing event listeners
    triggers.forEach((trigger) => {
        trigger.replaceWith(trigger.cloneNode(true))
    })

    // Re-query after replacing
    triggers = document.querySelectorAll('[data-accordion-trigger]')

    for (let i = 0; i < accordions.length; i++) {
        const accordion = accordions[i]
        const content = contents[i]
        const trigger = triggers[i]
        const activeClass = 'is-active'

        if (!trigger || !content) {
            console.warn('Missing accordion elements for index', i)
            continue
        }

        triggers[i].addEventListener('click', function () {
            console.log('Accordion clicked:', i)
            let height = content.scrollHeight

            for (let j = 0; j < contents.length; j++) {
                if (i == j) {
                    if (accordion.classList.contains(activeClass)) {
                        accordion.classList.remove(activeClass)
                    } else {
                        accordion.classList.add(activeClass)
                    }
                } else {
                    accordions[j].classList.remove(activeClass)
                }
            }
        })
    }
}
